module.exports = __webpack_public_path__ + "static/media/bg_shape_2.3ce21436.png";